import React from 'react';
import { useParams } from 'react-router-dom';
import DienstleisterListeSeite from './liste/DienstleisterListeSeite';
import DienstleisterSeite from './detail/DienstleisterSeite';

/** Bereich „Dienstleister“ im neuen Design (Handoff Dienstleister): Liste und Detail (/admin/dienstleister/:dienstleisterId). */
export default function DienstleisterBereich() {
  const { dienstleisterId } = useParams<{ dienstleisterId: string }>();
  // key: beim Wechsel des Dienstleisters neu aufbauen – offenes Panel schließt, Gruppe steht wieder auf „Alle“
  if (dienstleisterId) return <DienstleisterSeite key={dienstleisterId} dienstleisterId={dienstleisterId} />;
  return <DienstleisterListeSeite />;
}
